import { CartUpdateError } from './cartBadRequestError';

// List of error messages to ignore
const ignoringRequests = [
    'Credit Card tokenization is rejected by psp',
    'AddDiscountCodeToCartCommand has failed validation.',
    'AddPaymentMethodToCartCommand',
];

// List of errorCodes that should be ignored
const ignoreCodes = ['cart.couponactionfailure'];

/**
 * Determines whether the error should be ignored based on the error message or error code.
 * @param error - The error object
 * @returns boolean - True if the error should be ignored, false otherwise
 */
export const getShouldIgnoreError = (error?: unknown): boolean => {
    if (error instanceof CartUpdateError && error.errorDetails?.detail) {
        const includesIgnoringMessage = ignoringRequests.includes(
            error.errorDetails.detail
        );

        const includedIgnoreCode = error.errorDetails.errors?.some(err =>
            ignoreCodes.includes(err.errorCode)
        );

        return !!includesIgnoringMessage || !!includedIgnoreCode;
    }

    return false;
};
